var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCodeNormalWhiteDarkblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_1303)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.1632C0 8.57965 8.57965 0 19.1632 0H20.8368C31.4203 0 40 8.57965 40 19.1632C40 29.7467 31.4203 38.3264 20.8368 38.3264H19.1632C8.57965 38.3264 0 29.7467 0 19.1632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 23.5705L12.8 19.163L17.4 14.7555L16 13.4141L10 19.163L16 24.912L17.4 23.5705ZM22.6 23.5705L27.2 19.163L22.6 14.7555L24 13.4141L30 19.163L24 24.912L22.6 23.5705Z",
    fill: "#0033AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_1303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCodeNormalWhiteDarkblue);
export default __webpack_public_path__ + "static/media/ic_code_normal_white_darkblue.a2ddc0b4a65efb83a1f43014899a98c7.svg";
export { ForwardRef as ReactComponent };